import "./components/analytics"
import { bindCopyToClipboard } from "./components/copy-clipboard";
import { bindUniversitiesExplorer } from "./components/universities-explorer";

bindCopyToClipboard(".js-copy-whatsapp", {
    labelSelector: ".nodo-whatsapp-share__text",
    successText: "Link Copiado!",
    resetMs: 1800,
});

bindUniversitiesExplorer();
